import Language from './language';

type LanguageCacheKey = 'extensions' | 'filenames';

export default class LanguageCache {
  registry = {};
  registryCache = { extensions: {}, filenames: {} };

  register(language: Language) {
    // Ensure that extensions and filenames are not registered to multiple languages
    this.checkCache(language, 'extensions');
    this.checkCache(language, 'filenames');
    // @ts-ignore TODO: fix noImplicitAny error here
    this.registry[language.id] = language;
  }

  checkCache(language: Language, cacheKey: LanguageCacheKey) {
    const registeredFileIdentifiers: string[] = language[cacheKey] || [];
    const cache = this.registryCache[cacheKey];
    registeredFileIdentifiers.forEach(fileIdentifier => {
      if (Object.prototype.hasOwnProperty.call(cache, fileIdentifier)) {
        // @ts-ignore TODO: fix noImplicitAny error here
        const err = `Can't assign "${fileIdentifier}" to language "${language.id}" already bound to "${cache[fileIdentifier]}"`;
        throw new Error(err);
      } else {
        // @ts-ignore TODO: fix noImplicitAny error here
        cache[fileIdentifier] = language.id;
      }
    });
  }

  getById(id: string) {
    // @ts-ignore TODO: fix noImplicitAny error here
    return this.registry[id];
  }

  getByFileName(filename: string) {
    const matches = Object.keys(this.registry).filter(k => {
      // @ts-ignore TODO: fix noImplicitAny error here
      const entry = this.registry[k];
      return entry.filenames && entry.filenames.indexOf(filename) >= 0;
    });
    // @ts-ignore TODO: fix noImplicitAny error here
    return matches ? this.registry[matches[0]] : null;
  }

  getByExtension(extension: string | null) {
    const matches = Object.keys(this.registry).filter(
      // @ts-ignore TODO: fix noImplicitAny error here
      k => this.registry[k].extensions.indexOf(extension) >= 0
    );
    // @ts-ignore TODO: fix noImplicitAny error here
    return matches ? this.registry[matches[0]] : null;
  }
}
